import { Tag, Wrap, WrapItem, Text } from "@chakra-ui/react";

// max: show only the first N tags and a "+N" tag (omit to show all)
const TagList = ({ items = [], max }) => {
  if (!items.length) return <Text fontSize={13}>-</Text>;
  const shown = max ? items.slice(0, max) : items;
  const rest = max ? items.length - max : 0;

  return (
    <Wrap spacing={1} justify="center">
      {shown.map((item) => (
        <WrapItem key={item}>
          <Tag size="sm" colorScheme="blue" variant="subtle">
            {item}
          </Tag>
        </WrapItem>
      ))}
      {rest > 0 && (
        <WrapItem>
          <Tag size="sm" variant="outline">
            +{rest}
          </Tag>
        </WrapItem>
      )}
    </Wrap>
  );
};

export default TagList;